import { usageIds } from "../../../../constants/usageid.js";
export var FrequencyPlotConfigurationSchemaIds;
(function (FrequencyPlotConfigurationSchemaIds) {
    FrequencyPlotConfigurationSchemaIds["FREQUENCY_PLOT_CONFIGURATION"] = "frq-plt-config";
})(FrequencyPlotConfigurationSchemaIds || (FrequencyPlotConfigurationSchemaIds = {}));
export var FrequencyPlotConfigurationTags;
(function (FrequencyPlotConfigurationTags) {
    FrequencyPlotConfigurationTags["DEFAULT"] = "default";
})(FrequencyPlotConfigurationTags || (FrequencyPlotConfigurationTags = {}));
export const FrequencyPlotConfigurationTagsMap = {
    [FrequencyPlotConfigurationSchemaIds.FREQUENCY_PLOT_CONFIGURATION]: [
        FrequencyPlotConfigurationTags.DEFAULT
    ]
};
export const FrequencyPlotConfigurationUsageIds = usageIds(FrequencyPlotConfigurationTagsMap);
